import React,  { useState } from 'react';
import cn from './../../lib/bem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { showComboValidationCss } from '../../lib/utils/utilitarios';

import './dropdown_component.scss';

const DropDownComponent = ({label, placeholder, listDropDown, value, accion, msgValidador, focus, dropDownTipoBanco}) => {
    
    const classes = cn("dropdownComponent");
    const [ combo , mostrarCombo] = useState(false);

    const showValueDropdown = () => {
        var nameDropdown = placeholder;
        if( value !== '' ){
            nameDropdown = listDropDown.find((element) => element.codigo === value).descripcion;
        }
        return nameDropdown;
    }

    const colorSpanValue = () => {
        var spanColor = 'colorSpanPlah';
        if( value !== '' ){
            spanColor = 'colorSpanValue';
        }
        return spanColor;
    }

    const mensajeValidador = msgValidador === '' ? 'dropdownList' : 'dropdownList dropdownList-validador';

    return (
        <div className={classes()}>
            <div className={classes(showComboValidationCss(combo, msgValidador))} onClick={() => { mostrarCombo(!combo); focus() }}>
                <span data-testid={label} className={colorSpanValue()} >{ showValueDropdown() }</span>
                {
                    combo ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />
                }
            </div>
            {
                combo ? <div className={classes(mensajeValidador)}>
                                <ul data-testid={`${label}_ul`} onClick={() => { mostrarCombo(false); focus()}}>
                                    {
                                        listDropDown.map((list, i) => {
                                            return(
                                                <li data-testid={`${i}_li`} key={i} onClick={() => accion(list.codigo)}>{list.descripcion}</li>
                                            ) 
                                        })
                                    }
                                </ul>
                            </div> : null
            }
            {
                msgValidador !== '' ? <label className={classes('input-detalle-msgValidador')}>{msgValidador}</label> : null 
            }   
        </div>
    )

}

export default DropDownComponent;